import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthRoutes } from './auth/auth.routes';
import { AuthGuard } from './auth/services/auth.guard';
import { QuoteRoutes } from './quote/quote.routes';

const routes: Routes = [
  {
    path: QuoteRoutes.ROUTES.Quote.path,
    canLoad: [AuthGuard],
    loadChildren: () => import('./quote/quote.module').then((m) => m.QuoteModule),
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '**',
    redirectTo: AuthRoutes.ROUTES.Login.path,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
